import Hamburger from "hamburger-react";
import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "../../../pics/SponsaLogo.svg";
import { setCreatorData } from "../../../State/userProfileSlice";
import axios from "axios";
import API from "../../../api/api";
import APIDASH from "../../../api/apidash";
import { useDispatch, useSelector } from "react-redux";
import dummy from "../../../pics/dummy.png";

function HomeHeader({ BackGroundColor = "#000000" }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userlogin = useSelector((state) => state.auth);

  const [openHeader, setOpenHeader] = useState(false);
  const headRef = useRef(null);

  // Check if the user is logged in
  const isLoggedIn = userlogin.isAuthenticated;

  useEffect(() => {
    const hanldeCloseHead = (e) => {
      if (openHeader && !headRef.current.contains(e.target) && headRef) {
        setOpenHeader(false);
      }
    };
    document.addEventListener("mousedown", hanldeCloseHead);
    return () => {
      document.removeEventListener("mousedown", hanldeCloseHead);
    };
  }, [openHeader]);
  const handleClick = async () => {
    try {
      const response = await axios.get(
        API +
          "account/get_creator_data?uid=bajaycc&creatorUID=5096f366-2145-4c91-ae47-1e38efe06300",
      );
      const data = response.data;
      dispatch(
        setCreatorData({
          profileImage: data.image,
          coverImage: data.cover_image,
          displayName: data.display_name,
          userName: data.user_name,
          bio: data.bio,
          ytURL: data.yt_url,
          twitterURL: data.twitter_url,
          instaURL: data.insta_url,
          fbURL: data.fb_url,
        }),
      );
      navigate("/Velo_City/current-goals");
    } catch (error) {
      console.error("Error fetching creator data", error);
    }
  };
  const handleClick2 = async () => {
    try {
      const response = await axios.get(
        API +
          "account/get_creator_data?uid=bajaycc&creatorUID=5096f366-2145-4c91-ae47-1e38efe06300",
      );
      const data = response.data;
      dispatch(
        setCreatorData({
          profileImage: data.image,
          coverImage: data.cover_image,
          displayName: data.display_name,
          userName: data.user_name,
          bio: data.bio,
          ytURL: data.yt_url,
          twitterURL: data.twitter_url,
          instaURL: data.insta_url,
          fbURL: data.fb_url,
        }),
      );
      navigate("/explore");
    } catch (error) {
      console.error("Error fetching creator data", error);
    }
  };
  return (
    <div>
      <header
        className="  py-5 w-full"
        style={{ backgroundColor: `${BackGroundColor}` }}
      >
        <div className="  max-w-[1250px] mx-auto px-4 flex items-center justify-between ">
          <div className="">
            {isLoggedIn ? (
              userlogin.accountType === 1 ? (
                <Link to={`/${userlogin.sponsaUserName}/current-goals`}>
                  <img src={logo} alt="Sponsa" className="w-[230px]" />
                </Link>
              ) : (
                <Link to={"/explore"}>
                  <img src={logo} alt="Sponsa" className="w-[230px]" />
                </Link>
              )
            ) : (
              <Link to={"/"}>
                <img src={logo} alt="Sponsa" className="w-[230px]" />
              </Link>
            )}
          </div>
          <div className="relative" ref={headRef}>
            <button
              className="md:hidden block"
              onClick={() => setOpenHeader(!openHeader)}
            >
              <Hamburger
                color="white"
                toggled={openHeader}
                toggle={setOpenHeader}
              />
            </button>
            <div
              className={`list-none flex items-center md:flex-row flex-col md:relative absolute md:right-[unset] top-15  md:bg-transparent bg-black md:w-[unset] w-[175px] md:p-0 py-6 px-2 rounded-[6px] [transition:right_0.5s_cubic-bezier(0.72,0.45,0.22,0.75)] shadow-2xl  ${
                openHeader ? "right-[-1rem]" : " right-[-1000%]"
              } `}
              style={{ zIndex: 1000 }}
            >
              <ul
                className={`list-none  flex items-center md:flex-row flex-col [&>li_a]:mx-6 [&>li_a]:my-3  `}
              >
                <li>
                  <NavLink
                    to={"/explore"}
                    className={`CustomHomeNavLink CustomButtonAnim hover:bg-[#ffffff1e] rounded-full px-5 py-2  ${(
                      active,
                    ) => (active.isActive ? "" : "")}`}
                  >
                    Explore
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    className={`CustomHomeNavLink   ${(active) =>
                      active.isActive ? "" : ""}`}
                  >
                    Discover
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={`CustomHomeNavLink   ${(active) =>
                      active.isActive ? "" : ""}`}
                  >
                    About Us
                  </NavLink>
                </li> */}
              </ul>
              {isLoggedIn ? (
                userlogin.accountType === 1 ? (
                  <div className="flex items-center md:flex-row flex-col [&>button]:mx-5 [&>button]:px-6 [&>button]:py-2 [&>button]:md:my-0 [&>button]:my-1">
                    {/* <button
                      className="CustomHomeNavLink CustomButtonAnim text-[#030021] bg-[#00FF8F] rounded-[10px]"
                      onClick={() => navigate("/dashboard")}
                    >
                      Dashboard
                    </button> */}
                    <Link to="/dashboard" className="flex items-center">
                      <img
                        src={
                          userlogin.userImg
                            ? `${APIDASH}${userlogin.userImg}`
                            : dummy
                        }
                        alt=""
                        className="w-[35px] min-w-[35px] h-[35px] object-cover rounded-full"
                      />
                    </Link>
                  </div>
                ) : (
                  <div className="flex items-center md:flex-row flex-col [&>button]:mx-5 [&>button]:px-6 [&>button]:py-2 [&>button]:md:my-0 [&>button]:my-1">
                    {/* <button
                      className="CustomHomeNavLink CustomButtonAnim text-[#030021] bg-[#00FF8F] rounded-[10px]"
                      onClick={handleClick2}
                    >
                      Dashboard
                    </button> */}
                    <Link onClick={handleClick2} className="flex items-center">
                      <img
                        src={
                          userlogin.userImg
                            ? `${APIDASH}${userlogin.userImg}`
                            : dummy
                        }
                        alt=""
                        className="w-[35px] min-w-[35px] h-[35px] object-cover rounded-full"
                      />
                    </Link>
                  </div>
                )
              ) : (
                <div className="flex items-center md:flex-row flex-col [&>button]:mx-5 [&>button]:px-6 [&>button]:py-2 [&>button]:md:my-0 [&>button]:my-1">
                  <button
                    className="CustomHomeNavLink hover:bg-[#00FF8F] HoverDarker hover:text-[#030021] rounded-[10px] CustomButtonAnim"
                    onClick={() => navigate("/account")}
                  >
                    Log In
                  </button>
                  <button
                    className="CustomHomeNavLink CustomButtonAnim text-[#030021] bg-[#00FF8F] rounded-[10px] HoverDarker"
                    onClick={() => navigate("/signup/")}
                  >
                    Sign Up
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default HomeHeader;
